<div>
  <ng-container *ngIf="status === 'processing'; else callbackError">
    <div class="mt-fdk-xl text-center flex flex-1 flex-col items-center">
      <fdk-illustration name="sign-in" />
      <fdk-loading-dots class="mt-fdk-s" />
      <h2 class="fdk-type-heading-2 text-fdk-primary mt-fdk-l">
        Finishing sign-in
      </h2>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
        We're confirming your identity. This usually takes just a few seconds.
      </p>
    </div>

    <div class="flex justify-center text-[#5B47FB]">
      <fdk-spinner />
    </div>
  </ng-container>

  <ng-template #callbackError>
    <div class="mt-fdk-xl text-center">
      <fdk-illustration name="warning" />
      <h2 class="fdk-type-heading-2 text-fdk-primary mt-fdk-l">
        We could not complete sign-in
      </h2>
      <p class="fdk-type-paragraph text-fdk-secondary mt-fdk-xxs">
        Please check the details below and try again.
      </p>
    </div>

    <div class="bg-gray-100 p-4 rounded-md text-left">
      <h3 class="text-md font-medium">Error Details:</h3>
      <p class="text-sm text-gray-800">
        Error Type: <span class="font-semibold">{{ error }}</span>
      </p>
      <p class="text-sm text-gray-800">
        Description: <span>{{ errorDescription }}</span>
      </p>
      <p *ngIf="errorUri" class="text-sm text-gray-800 break-words">
        More Info:
        <a
          [href]="errorUri"
          class="font-medium text-[#5B47FB] hover:text-[#4936E8]"
          >{{ errorUri }}</a
        >
      </p>
    </div>

    <div class="mt-fdk-m flex justify-center">
      <fdk-button
        [routerLink]="'/auth/signin'"
        type="button"
        variant="secondary"
      >
        Back to Sign In
      </fdk-button>
    </div>
  </ng-template>
</div>
